import {Frontend} from "./frontend";

(function () {
    XonBoard.Sites = {
        list: {

            selectors: {
                sites_table: $('#sites-table'),
                count_label: $('#count-label'),
            },

            init: function () {

                let self = this;
                let table = this.selectors.sites_table.DataTable({
                    bInfo: false,
                    bLengthChange: false,
                    processing: true,
                    serverSide: true,
                    ajax: {
                        url: this.selectors.sites_table.data('ajax_url'),
                        type: 'post',
                        dataSrc(json) {
                            self.updateCount(json.recordsFiltered);
                            return json.data;
                        }
                    },
                    columns: [
                        {data: 'name', name: 'sites.name'},
                        {
                            data: 'latitude',
                            name: 'sites.latitude',
                            searchable: false,
                            sortable: false,
                            render: (latitude, type, site) => XonBoard.Map.locationCell(latitude, site.longitude)
                        },
                        {data: 'zone_name', name: 'zones.name'},
                        {data: 'actions', name: 'actions', searchable: false, sortable: false}
                    ],
                    order: [[0, "asc"]],
                    searchDelay: 500,
                    dom: 'lBfrtip',
                    "createdRow": function (row, data, dataIndex) {
                        Frontend.Utils.dtAnchorToForm(row);
                    }
                });
                Frontend.DataTable.init(table);
                Frontend.DataTableSearch.init(table);
                XonBoard.Utils.Select2.init();
            },
            updateCount(total) {
                this.selectors.count_label.text(total);
            },
            upload(input, url, messages) {
                if (!input.files.length) {
                    return;
                }

                const form = new FormData();
                form.append('file', input.files[0]);
                toastr.info(messages.uploading);

                fetch(url, {
                    method: 'POST',
                    body: form,
                    headers: {'X-CSRF-TOKEN': XonBoard.Utils.csrf, 'Accept': 'application/json'}
                })
                    .then(async (response) => {
                        if (response.ok) {
                            toastr.success(messages.success);
                            this.selectors.sites_table.DataTable().ajax.reload();
                        } else {
                            const data = await response.json().catch(() => ({}));
                            toastr.error(data.message || messages.failed);
                        }
                    })
                    .catch(() => toastr.error(messages.failed))
                    .finally(() => input.value = '');
            },
        },

        edit: {
            selectors: {},

            init: function (locale) {
                this.addHandlers(locale);
                XonBoard.tinyMCE.init(locale);
            },

            addHandlers: function (locale) {
            },
        },
    }
})();
